(function () {
  if (window.EzupProductGalleryReferenceArrows) return;
  window.EzupProductGalleryReferenceArrows = true;

  function isVisibleThumbnail(thumbnail) {
    return !thumbnail.classList.contains('is-filtered') && thumbnail.getClientRects().length > 0;
  }

  function setupGallery(gallery) {
    var controls = gallery.querySelector('[data-gallery-reference-arrows]');
    if (!controls || controls.dataset.initialized === 'true') return;

    controls.dataset.initialized = 'true';

    var previousButton = controls.querySelector('[data-gallery-reference-arrow="previous"]');
    var nextButton = controls.querySelector('[data-gallery-reference-arrow="next"]');

    function visibleThumbnails() {
      return Array.prototype.filter.call(
        gallery.querySelectorAll('.product-gallery__thumbnail'),
        isVisibleThumbnail
      );
    }

    function selectedIndex(thumbnails) {
      var index = thumbnails.findIndex(function (thumbnail) {
        return thumbnail.classList.contains('is-nav-selected');
      });

      if (index >= 0) return index;

      var selectedMedia = gallery.querySelector(
        '.product-gallery__carousel-item.is-selected:not(.is-filtered)'
      );
      if (!selectedMedia) return 0;

      var selectedMediaId = selectedMedia.getAttribute('data-media-id');
      index = thumbnails.findIndex(function (thumbnail) {
        return thumbnail.getAttribute('data-media-id') === selectedMediaId;
      });

      return index >= 0 ? index : 0;
    }

    function update() {
      var thumbnails = visibleThumbnails();
      var index = selectedIndex(thumbnails);

      controls.hidden = thumbnails.length < 2;
      previousButton.disabled = thumbnails.length < 2 || index <= 0;
      nextButton.disabled = thumbnails.length < 2 || index >= thumbnails.length - 1;
    }

    function move(direction) {
      var thumbnails = visibleThumbnails();
      var index = selectedIndex(thumbnails);
      var target = thumbnails[index + direction];

      if (target) target.click();
      window.requestAnimationFrame(update);
    }

    previousButton.addEventListener('click', function () {
      move(-1);
    });

    nextButton.addEventListener('click', function () {
      move(1);
    });

    new MutationObserver(update).observe(gallery, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    update();
  }

  function setupAllGalleries(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll
      ? scope.querySelectorAll('.product-gallery')
      : [];

    Array.prototype.forEach.call(galleries, setupGallery);
  }

  function initialize() {
    setupAllGalleries(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAllGalleries(event.target);
  });
})();
